import React, { useEffect, useState } from 'react';
import PageBody from '../../components/pagebody/PageBody';
import { Route, Routes } from 'react-router-dom';
import ViewNotice from './viewnotice/ViewNotice';
import { PAGE_PATH, PAGE_PERMISSIONS } from '../dashboard/constants/constant';
import NoticesList from './noticelist/NoticesList';
import { isAccessAllowed, useUserPermissionsInfo } from '../dashboard/hooks/userHooks';
import PurchaseNoticePlan from './noticeplan/PurchaseNoticePlan';

export default function NoticesSection() {
	const { permissions } = useUserPermissionsInfo();

	const noticeAccess = isAccessAllowed(PAGE_PERMISSIONS.VIEW_NOTICES, permissions)

	return (
		<PageBody>
			<Routes>
				<Route exact path={"/"} element={noticeAccess ? <NoticesList /> : <PurchaseNoticePlan />} />
				<Route path={PAGE_PATH.VIEW} element={<ViewNotice />} replace={true} />
			</Routes>
		</PageBody>
	)
}